/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './hospital-payment.reducer';

export const HospitalPaymentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const hospitalPaymentEntity = useAppSelector(state => state.hospitalPayment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="hospitalPaymentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.hospitalPayment.detail.title">HospitalPayment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.id">Id</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.id}</dd>
          <dt>
            <span id="writtenOn">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.writtenOn">Written On</Translate>
            </span>
          </dt>
          <dd>
            {hospitalPaymentEntity.writtenOn ? (
              <TextFormat value={hospitalPaymentEntity.writtenOn} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="toRealizeOn">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.toRealizeOn">To Realize On</Translate>
            </span>
          </dt>
          <dd>
            {hospitalPaymentEntity.toRealizeOn ? (
              <TextFormat value={hospitalPaymentEntity.toRealizeOn} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="paymentMethod">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.paymentMethod">Payment Method</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.paymentMethod}</dd>
          <dt>
            <span id="realized">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.realized">Realized</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.realized ? 'true' : 'false'}</dd>
          <dt>
            <span id="realizedOn">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.realizedOn">Realized On</Translate>
            </span>
          </dt>
          <dd>
            {hospitalPaymentEntity.realizedOn ? (
              <TextFormat value={hospitalPaymentEntity.realizedOn} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="realizationComments">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.realizationComments">Realization Comments</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.realizationComments}</dd>
          <dt>
            <span id="comments">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.comments">Comments</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.comments}</dd>
          <dt>
            <span id="chequeRefNo">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.chequeRefNo">Cheque Ref No</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.chequeRefNo}</dd>
          <dt>
            <span id="chequeDate">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.chequeDate">Cheque Date</Translate>
            </span>
          </dt>
          <dd>
            {hospitalPaymentEntity.chequeDate ? (
              <TextFormat value={hospitalPaymentEntity.chequeDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="creditCardRefNo">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.creditCardRefNo">Credit Card Ref No</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.creditCardRefNo}</dd>
          <dt>
            <span id="transactionRefNo">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.transactionRefNo">Transaction Ref No</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.transactionRefNo}</dd>
          <dt>
            <span id="paidValue">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.paidValue">Paid Value</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.paidValue}</dd>
          <dt>
            <span id="insuranceRefNo">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.insuranceRefNo">Insurance Ref No</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.insuranceRefNo}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.active">Active</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>
            {hospitalPaymentEntity.microSec ? (
              <TextFormat value={hospitalPaymentEntity.microSec} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>
            {hospitalPaymentEntity.timestampEntry ? (
              <TextFormat value={hospitalPaymentEntity.timestampEntry} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>
            {hospitalPaymentEntity.lastUpdated ? (
              <TextFormat value={hospitalPaymentEntity.lastUpdated} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.cursor}</dd>
          <dt>
            <span id="paymentStatus">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.paymentStatus">Payment Status</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.paymentStatus}</dd>
          <dt>
            <span id="billOrigin">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.billOrigin">Bill Origin</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.billOrigin}</dd>
          <dt>
            <span id="collectedById">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.collectedById">Collected By Id</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.collectedById}</dd>
          <dt>
            <span id="collectedByType">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.collectedByType">Collected By Type</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.collectedByType}</dd>
          <dt>
            <span id="lastUpdatedById">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.lastUpdatedById">Last Updated By Id</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.lastUpdatedById}</dd>
          <dt>
            <span id="gatewayVendor">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.gatewayVendor">Gateway Vendor</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.gatewayVendor}</dd>
          <dt>
            <span id="accountOrCardNo">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.accountOrCardNo">Account Or Card No</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.accountOrCardNo}</dd>
          <dt>
            <span id="accountHolderName">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.accountHolderName">Account Holder Name</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.accountHolderName}</dd>
          <dt>
            <span id="cardExpiryDate">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.cardExpiryDate">Card Expiry Date</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.cardExpiryDate}</dd>
          <dt>
            <span id="voided">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.voided">Voided</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.voided ? 'true' : 'false'}</dd>
          <dt>
            <span id="voidedReason">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.voidedReason">Voided Reason</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.voidedReason}</dd>
          <dt>
            <span id="voidedDate">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.voidedDate">Voided Date</Translate>
            </span>
          </dt>
          <dd>{hospitalPaymentEntity.voidedDate}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalPayment.insuranceOrBank">Insurance Or Bank</Translate>
          </dt>
          <dd>{hospitalPaymentEntity.insuranceOrBank ? hospitalPaymentEntity.insuranceOrBank.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalPayment.cashTransaction">Cash Transaction</Translate>
          </dt>
          <dd>{hospitalPaymentEntity.cashTransaction ? hospitalPaymentEntity.cashTransaction.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalPayment.claim">Claim</Translate>
          </dt>
          <dd>{hospitalPaymentEntity.claim ? hospitalPaymentEntity.claim.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalPayment.admission">Admission</Translate>
          </dt>
          <dd>{hospitalPaymentEntity.admission ? hospitalPaymentEntity.admission.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalPayment.bill">Bill</Translate>
          </dt>
          <dd>{hospitalPaymentEntity.bill ? hospitalPaymentEntity.bill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalPayment.subscriber">Subscriber</Translate>
          </dt>
          <dd>{hospitalPaymentEntity.subscriber ? hospitalPaymentEntity.subscriber.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/hospital-payment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/hospital-payment/${hospitalPaymentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HospitalPaymentDetail;
